// Filters can be used to apply common text formatting. The filter’s function
// always receives the expression’s value (the result of the former chain) as
// its first argument. In the above example, the capitalize filter function
// will receive the value of message as its argument.
// Filters can be chained:
// {{ message | filterA | filterB }}
import Vue from 'vue';

Vue.filter('uppercase', value =>
  !value ? '' : value.toString().toUpperCase()
);
Vue.filter('lowercase', value =>
  !value ? '' : value.toString().toLowerCase()
);

Vue.filter('caps', value => {
  if (!value) return '';
  const string = value.toString();
  return string.charAt(0).toUpperCase() + string.slice(1);
});

Vue.filter('capitalize', value => {
  if (!value) return '';
  const string = value.toString();
  return string.charAt(0).toUpperCase() + string.slice(1);
});

Vue.filter('append', (value, suffix) =>
  !value ? '' : value.toString() + suffix
);
Vue.filter('prepend', (value, prefix) =>
  !value ? '' : prefix + value.toString()
);

Vue.filter('truncate', (value, length) => {
  if (!value) return '';
  let valueLength = length;
  valueLength = length || 15;
  const string = value.toString();
  return string.length <= valueLength
    ? string
    : `${string.substring(0, valueLength)}...`;
});

Vue.filter('trim', value => (!value ? '' : value.toString().trim()));
